import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import useCurrentInstance from "@/hooks/useCurrentInstance";
import UpLoadImg from "@/components/UpLoadImg/index.vue";
import Process from "@/components/WriteProcess/index.vue";
import { ArrowRight } from "@element-plus/icons";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  name: "Progress",
  components: {
    Head: Head,
    UpLoadImg: UpLoadImg,
    ArrowRight: ArrowRight,
    Process: Process
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter(); //跟进记录描述

    var RefProcess = ref();
    var form = reactive({
      helpingRecords: "",
      helpPhoto: "",
      objectId: useRoute().query.objectId
    }); // 返回

    function back() {
      router.back();
    }

    function submit() {
      return _submit.apply(this, arguments);
    }

    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var b, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return RefProcess.value.verify();

              case 2:
                b = _context.sent;

                if (!b) {
                  _context.next = 10;
                  break;
                }

                form.helpingRecords = b.content;
                form.helpPhoto = b.imgs;
                _context.next = 8;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["addHelpInPairsProcess"](form);

              case 8:
                res = _context.sent;

                if (res.code == 0) {
                  ElMessage.success("添加成功");
                  setTimeout(function () {
                    router.back();
                  }, 300);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _submit.apply(this, arguments);
    }

    return {
      form: form,
      RefProcess: RefProcess,
      submit: submit,
      back: back
    };
  }
});